import { AbstractEntity, PropertyValuesDictionary, Transaction, UiData } from "plethora-lib" // GENERATED
import {
  DataTypeShapeType,
  DataTypeDirection,
  DataTypeSize,
  DataTypeColor,
} from "../GeneratedClasses/GeneratedDataTypes" // GENERATED
import { GeneratedPlayer } from "../GeneratedClasses/GeneratedPlayer" // GENERATED

export class Player extends GeneratedPlayer {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super(id, propertyValues, uiData)

    // YOUR CREATE CODE HERE
  }

  public onDelete(uiData: UiData): void /* GENERATED */ {
    super.onDelete(uiData)
    // YOUR CODE HERE
  }

  public onDestory(): void /* GENERATED */ {
    super.onDestory()
    // YOUR CODE HERE
  }

  public onSetHighlight(highlight: boolean): void /* GENERATED */ {
    super.onSetHighlight(highlight)
    // YOUR CODE HERE
  }

  protected onDirectionUpdate(
    newValue: DataTypeDirection,
    oldValue: DataTypeDirection,
    uiData: UiData
  ): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onXUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onYUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onTurnDown(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onTurnUp(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onTurnRight(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onTurnLeft(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onStep1(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onStep3(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onStep2(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onClick(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onMeets(isActivator: boolean, otherEntity: AbstractEntity, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }
}
